// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { nativeVerticalScrollStyles } from 'components/common/scroll/nativeScrollStyles';
import styled from 'styled-components';
import DataTile from './DataTile';
import useIsQC from 'hooks/useIsQC';
import React from 'react';
import { ModelClassMessage } from '@tls/sw91-communication/types/com.base';
import { LabelPackageInfoMessage } from '@tls/sw91-communication/types/com.api_db_access';

interface Props {
  filteredLabels: LabelPackageInfoMessage[];
  projectTags: string[];
  modelClasses: ModelClassMessage[];
}

export default function DataGrid({ filteredLabels, projectTags, modelClasses }: Readonly<Props>) {
  const isQC = useIsQC();

  return (
    <Tiles>
      {filteredLabels.map(label => (
        <DataTile
          key={label.imageName}
          labelPackage={label}
          projectTags={projectTags}
          isQC={isQC}
          modelClasses={modelClasses}
        />
      ))}
    </Tiles>
  );
}

const Tiles = styled.div`
  flex: 1;
  margin: 0 0.5rem;
  ${nativeVerticalScrollStyles};
  overflow-x: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, 18rem);
  gap: 1rem;
  grid-auto-rows: auto;
  justify-items: start;
  align-items: start;
  padding: 1rem 0;
`;
